import { CreditCard } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { useCartIsOpen } from '@/app/cart/useCartIsOpen';

export const CartActions = ({ cart }) => {
  const { closeCart } = useCartIsOpen();

  const handleClick = () => {
    closeCart();
  };

  return (
    <div className="flex flex-col gap-2 mt-4">
      <Button className="w-full" asChild>
        <Link to={`/cart/${cart.id}`} onClick={handleClick}>
          <CreditCard className="mr-2 h-4 w-4" />
          Checkout
        </Link>
      </Button>
    </div>
  );
};

export default CartActions;
